import React from 'react'
import {
	MainContainer,
	FooterContainer,
	Title,
	SubTitle,
	Question,
	ConfirmationButton,
	DenyButton,
} from './confirm-modal.styles'

class ConfirmModal extends React.Component {
	render() {
		return (
			<MainContainer>
				<Title>Confirmar reserva de poltrona</Title>
				<SubTitle>
					O cancelamento de bilhete é permitido até 03 horas antes do
					início da viagem. Esta compra não permitirá cancelamento.
				</SubTitle>
				<Question>Você deseja prosseguir mesmo assim?</Question>
				<FooterContainer>
					<ConfirmationButton
						onClick={() => {
							this.props.changeModalStatus()
							this.props.tripOptionOnSelect()
						}}>
						Sim
					</ConfirmationButton>
					<DenyButton onClick={this.props.changeModalStatus}>
						Não
					</DenyButton>
				</FooterContainer>
			</MainContainer>
		)
	}
}

export default ConfirmModal
